import React from 'react';
import { createContainer } from 'react-tracked';
export var SparkflowBlinkActionType;
(function (SparkflowBlinkActionType) {
    SparkflowBlinkActionType[SparkflowBlinkActionType["UPDATE_SPARKFLOW_GLOBAL_CONTEXT"] = 0] = "UPDATE_SPARKFLOW_GLOBAL_CONTEXT";
    SparkflowBlinkActionType[SparkflowBlinkActionType["REQUEST_CHECKLIST_REFRESH"] = 1] = "REQUEST_CHECKLIST_REFRESH";
})(SparkflowBlinkActionType || (SparkflowBlinkActionType = {}));
export const defaultSparkflowContextOptions = {
    hideSparkflowBanner: false,
    spotterVizConfig: {
        prefilledSampleQuestion: undefined,
        starterPrompts: undefined,
    },
    spotbuildGenResponse: [],
    isLoadingIndicatorVisible: false,
    checklistRefreshRequested: false,
    lastOpenedChecklistSectionId: undefined,
};
const reducer = (state = defaultSparkflowContextOptions, action) => {
    switch (action.type) {
        case SparkflowBlinkActionType.UPDATE_SPARKFLOW_GLOBAL_CONTEXT:
            return { ...state, ...action.data };
        case SparkflowBlinkActionType.REQUEST_CHECKLIST_REFRESH:
            return { ...state, ...action.data };
        default:
            return state;
    }
};
const getDispatcherFunctions = (dispatch) => ({
    updateSparkflowGlobalContext: (data) => {
        dispatch({
            type: SparkflowBlinkActionType.UPDATE_SPARKFLOW_GLOBAL_CONTEXT,
            data,
        });
    },
    requestChecklistRefresh: (data) => {
        dispatch({
            type: SparkflowBlinkActionType.REQUEST_CHECKLIST_REFRESH,
            data,
        });
    },
});
function getOrCreateContainer() {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window.blink) === null || _a === void 0 ? void 0 : _a.sparkflowBlinkContainer) {
        return window.blink.sparkflowBlinkContainer;
    }
    const { Provider, useTrackedState, useUpdate } = createContainer(({ initialState }) => React.useReducer(reducer, initialState));
    const container = {
        Provider,
        useTrackedState,
        useDispatch: useUpdate,
    };
    window.blink = window.blink || {};
    window.blink.sparkflowBlinkContainer = container;
    return container;
}
const { Provider: InternalProvider, useTrackedState, useDispatch, } = getOrCreateContainer();
const SparkflowContextProvider = ({ children, value = {}, }) => (React.createElement(InternalProvider, { initialState: { ...defaultSparkflowContextOptions, ...value } }, children));
const getSparkflowGlobalContext = () => {
    try {
        return useTrackedState() || defaultSparkflowContextOptions;
    }
    catch (e) {
        if (/Please use <Provider>/.test(e === null || e === void 0 ? void 0 : e.message)) {
            return {};
        }
        throw e;
    }
};
const setSparkflowGlobalContext = () => {
    const dispatch = useDispatch();
    return dispatch
        ? getDispatcherFunctions(dispatch)
        : {};
};
export { SparkflowContextProvider, getSparkflowGlobalContext, setSparkflowGlobalContext, };
//# sourceMappingURL=sparkflow-context.js.map